import script from "./payContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./payContent.vue?vue&type=script&lang=ts&setup=true"

import "./payContent.vue?vue&type=style&index=0&id=477c626c&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-477c626c"]])

export default __exports__